<div style="text-align:center; margin: 5em 3em;">
  <h1>{{keys.welcome | translate}}</h1>
  <yosite-logo></yosite-logo>
</div>
